import QuoteFragment from './QuoteFragment';
export default `
	mutation CreateQuote($input: CreateQuoteInput!) {
		createQuote(input: $input) {
			...QuoteFragment
		}
	}
	${QuoteFragment}
`;
